import { render, staticRenderFns } from "./LandingIndexComponent.vue?vue&type=template&id=0d9991b2"
import script from "./LandingIndexComponent.vue?vue&type=script&lang=js"
export * from "./LandingIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports